/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupWithControlCountDto
 */
export interface GroupWithControlCountDto {
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    groupClass?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    catalogId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    catalogName?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    parentGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithControlCountDto
     */
    parentGroupName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupWithControlCountDto
     */
    hasControls?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupWithControlCountDto
     */
    hasSubGroups?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GroupWithControlCountDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupWithControlCountDto
     */
    updated?: Date;
    /**
     * 
     * @type {number}
     * @memberof GroupWithControlCountDto
     */
    controlCount?: number;
}

/**
 * Check if a given object implements the GroupWithControlCountDto interface.
 */
export function instanceOfGroupWithControlCountDto(value: object): value is GroupWithControlCountDto {
    return true;
}

export function GroupWithControlCountDtoFromJSON(json: any): GroupWithControlCountDto {
    return GroupWithControlCountDtoFromJSONTyped(json, false);
}

export function GroupWithControlCountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupWithControlCountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'groupClass': json['groupClass'] == null ? undefined : json['groupClass'],
        'catalogId': json['catalogId'] == null ? undefined : json['catalogId'],
        'catalogName': json['catalogName'] == null ? undefined : json['catalogName'],
        'parentGroupId': json['parentGroupId'] == null ? undefined : json['parentGroupId'],
        'parentGroupName': json['parentGroupName'] == null ? undefined : json['parentGroupName'],
        'hasControls': json['hasControls'] == null ? undefined : json['hasControls'],
        'hasSubGroups': json['hasSubGroups'] == null ? undefined : json['hasSubGroups'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'controlCount': json['controlCount'] == null ? undefined : json['controlCount'],
    };
}

export function GroupWithControlCountDtoToJSON(json: any): GroupWithControlCountDto {
    return GroupWithControlCountDtoToJSONTyped(json, false);
}

export function GroupWithControlCountDtoToJSONTyped(value?: GroupWithControlCountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'groupId': value['groupId'],
        'title': value['title'],
        'description': value['description'],
        'groupClass': value['groupClass'],
        'catalogId': value['catalogId'],
        'catalogName': value['catalogName'],
        'parentGroupId': value['parentGroupId'],
        'parentGroupName': value['parentGroupName'],
        'hasControls': value['hasControls'],
        'hasSubGroups': value['hasSubGroups'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'controlCount': value['controlCount'],
    };
}

